import React from 'react';

import Layout from './SidePanelLayout';
import IndeterminateLoading from '../../../../components/Loading/IndeterminateLoading';

export const ViewOrderSidePanelLoading = () => {
  return (
    <Layout>
      <div className="loading">
        <IndeterminateLoading />
      </div>
    </Layout>
  );
};
